// Note: This example requires that you consent to location sharing when
// prompted by your browser. If you see the error "The Geolocation service
// failed.", it means you probably did not give permission for the browser to
// locate you.
let map, infoWindow, limits, markers;

const pet_zoom = 16;
const page_type = $('#display_type').val();
var pets = [];
var pOrder = [];
var ptOrder = [];
var pageState = 'listing';
var pop_nav = 0;
var scrollOffset = 0;
var orig_title = $('head title').text().split(' - ');
var new_title = $('head title').text().split(' - ');
var viewMode = null;

var macy = 	Macy({
		container: '#pet_list',
		trueOrder: true,
		waitForImages: false,
		useImageLoader: true,
		margin: 24,
		columns: 3,
		breakAt: {
			960: 2,
			720: 1
		}
	});

macy.runOnImageLoad(function (event) {
	//console.log('macy image load detected tet');
	//console.log(event);
	if (event.data.img) {
	  // note: this parameter can be undefined if it is the final completion event that is emitted.
	  //console.log(event.data.img);
	}

	macy.recalculate(true);
}, true);

macy.on(macy.constants.EVENT_RECALCULATED, function (ctx) {
  //console.log('macy recalculated');
});

markers = [];

jQuery(function($){ //on document.ready
	$.when( loginCheck,	petTypesGet(), petStatusesGet(), petsGet(), delReasonsGet() ).then(function() {
		$('#pets-wait').hide();
		$('.loading_msg').hide();

		//console.log(window.location);
		//console.log(window.location.href);
		//console.log(window.location.pathname);
		//console.log(window.location.search);
		//console.log(window.location);

		// Parse URL and determine display mode
		var plRegex = RegExp('\/pet\/(.*)','g');
		pl = plRegex.exec(window.location.href);
		if (pl){
			let pet_id = pl[1];
			if (pet_id.indexOf('?') != -1) {
				pet_id = pet_id.substring(0, pet_id.indexOf('?'));
			}
			if (pet_id.indexOf('#') != -1) {
				pet_id = pet_id.substring(0, pet_id.indexOf('#'));
			}
			view_pet(pet_id);
		} else {
			//console.log('No cat selected - show all');
			var paths = window.location.pathname.split('/');
			//console.log(paths);
			viewMode = paths[2];
			view_pets(paths[2]);
		}

		// Deal with virtual page navigation
		window.onpopstate = function (e) {
			//console.log('pop');
			//console.log(e);
			if (e.state) {
				var s = e.state;
				pop_nav = 1;
				//console.log(s);
				switch (s.action) {
					case 'load_pets':
						//console.log('pop to list');
						//console.log(s.dMode);
						$('.show_pets').click();
					break;
					case 'view_pet':
						//console.log('pop to article');
						view_pet(s.pet_id);
					break;
					default:
						//console.log('pop default');
						view_pets(viewMode);
					break;
				}
			}
		}

	});


	$(document).on('click', '.view_pet', function(e){
		e.preventDefault();
		//console.log('View Pet');
		view_pet($(this).data('pet_id'));
	});

	$(document).on('click', '.approve_pet', function(e){
		e.preventDefault();
		console.log($(this).data('pet_id'));
		console.log($(this));
		console.log(this);
	})


	$(document).on('click', '.show_pets', function(e){
		e.preventDefault();
		console.log('View All Pets');
		$('#pet-detail').hide();
		$('#pet_list').show();
		view_pets(viewMode);
		macy.recalculate(true);
		map.fitBounds(limits);
	});

	$(document).on('click', '.approve_pet', function(e){
		e.preventDefault();
		$('#admin-wait').show();
		$.ajax({
			type  : 'GET',
			url   : '/admin/pets/utils/approve_pet.php',
			data  : {"pet_id": $(this).data('pet_id')},
			dataType  : 'json',
			encode  : true
		})
		.done(function(data) {
			if ( ! data.success) {
				// Error - show it to the user
				var error_message = '';
				$.each(data.errors, function (i,v) {
					error_message = error_message + "<br>" + v;
				});
			$("#admin-err-msg").html(error_message);
			$("#admin-err").modal("show");
			$("#admin-wait").hide();
			$('html, body').animate({scrollTop: scrollOffset}, 100, "easeInOutExpo", function() {});
		} else {
			let pet_id = data.pet_id;
			$('#admin-err').hide();
			$("#admin-wait").hide();
			$('#pet_' + pet_id).find('.needs-approval').removeClass('needs-approval');
			$('#pet_' + pet_id).find('.approve_pet').removeClass('.remove_pet').removeClass('btn-brand-primary').addClass('disabled btn-success').text('Approved');
			$('#approved_modal').modal('show');
		}
		})
		.fail(function(XMLHttpRequest, textStatus, errorThrown) {
			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);
			$('#admin-err-msg').text(textStatus + ': ' + errorThrown);
			$('#admin-wait').hide();
			$('#admin-err').show();
			$('html, body').animate({scrollTop: scrollOffset}, 100, "easeInOutExpo", function() {});
		});

	});

	$(document).on('click', '.contact_submitter', function(e){
		if (userLoggedIn) {
			$.ajax({
				type  : 'GET',
				url   : '/utils/get_user.php',
				data  : {user_id: $(this).data('user_id')},
				dataType  : 'json',
				encode  : true
			})
			.done(function(data) {
				if ( ! data.success) {
					// Error - show it to the user
				$('.submitter_error').html(data.error_msg).fadeIn();
			} else {
    		strippedPhone = data.user.phone.replace(/\D/g,'');
				$('.sub_name').text(data.user.fname + ' ' + data.user.lname);
				$('.sub_email').html('<a href="mailto:' + data.user.email + '">' + data.user.email +  '</a>');
				$('.sub_phone').html('<a href="tel:' + strippedPhone + '">' + data.user.phone +  '</a>');
				$('.submitter_error').hide();
				$('.contact_submitter').fadeOut();
				$('.submitter_data').fadeIn();
			}
			});

		} else {
			$('.submitter_error').html('You must be <a href="/login.html?return_url=' + window.location.pathname + '">logged in</a> to view that information.').fadeIn();
		}
	})

	$(document).on('click', '.map_pet', function(e){
		e.preventDefault();
		$('html, body').animate({scrollTop: $('#pet_map').offset().top}, 100);
		let petID = $(this).parents('.pet-listing').data('pet_id')
		$('.pet-listing').removeClass('border-brand-primary').addClass('border-gray-300');
		$(this).removeClass('border-gray-300').addClass('border-brand-primary');
		$.each(markers, function(i,m){
			if (m.markerFor == petID) {
				map.panTo(m.getPosition());
				map.setZoom(parseInt(pet_zoom));
				return false;
			}
		})
	})

	$(document).on('click', '.show_all_on_map', function(e){
		e.preventDefault();
		map.fitBounds(limits);
	})

	$(document).on('click', '.center_map_on_me', function(e){
		e.preventDefault();
		$('.loading_msg').show();
		$('.map-error').hide();
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(
				(position) => {
					const pos = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
					$('.loading_msg').hide();
					map.setCenter(pos);
					map.setZoom(18);
				},
				() => {
					handleLocationError(true, infoWindow, map.getCenter());
				}
			);
		} else {
			// Browser doesn't support Geolocation
			handleLocationError(false, infoWindow, map.getCenter());
		}
	});


	// Del link handler
	$(document).on('click', '.del_pet', function(e) {
		e.preventDefault();

		let lof;

		if (pets[$(this).data('id')].status == 6) {
			lof = 1;
		} else {
			lof = 2;
		}


		$('#del_reason_input').empty().change();
		$('#del_descr').val('');
		$('#del_reason_input').append('<option value="">Please Select</option>');
		$.each(del_statuses, function(i,d) {
			if (d.lorf == lof) {
				$('#del_reason_input').append('<option value="' + d.del_id + '">' + d.name + '</option>');
			}
		})

		$('#delModal').modal('show');
		$('.confirm_del').data('pet_id', $(this).data('id'));
	})


	$(document).on('change', '#del_reason_input', function() {
		if ($(this).val()) {
			$('.confirm_del').removeAttr('disabled');
		} else {
			$('.confirm_del').attr('disabled', 'disabled');
		}
	})


	$(document).on('click', '.confirm_del', function(e) {
		e.preventDefault();
		delPet($(this).data('pet_id'));
		$('#delModal').modal('hide');
	})

});


function view_pet(pet_id) {
	//console.log('Show pet: ' + pet_id);
	pageState = 'detail';

	let p = pets[pet_id];

	if (p) {

		$('#no-pet').hide();
		$('.pet_map_wrapper').show();


		let d = $('#pet-detail');
		let social_img = '';

		if (viewMode == null) {
			if (p.status == 6) {
				viewMode = 'lost';
			} else {
				viewMode = 'found';
			}
		}

		updateLables();

		$('.lost_pets_message, .found_pets_message').hide();

		$('.map-controls').hide();
		$('.show_pets').show();

		new_title[0] = 'Pet Details';
		$('head > title').text(new_title.join(' - '));

		if (pop_nav == 1) {
			pop_nav = 0;
		} else {
			history.pushState({
				'action': 'view_pet', 'pet_id': pet_id
			}, 'view_pet', '/pet/' + pet_id);
		}

		$('a.login').attr('href', '/login.html?return_url=' + window.location.pathname);


		d.find('.pet_name').text(p.name);
		d.find('.pet_type').text(pet_types[p.pet_type].name);
		d.find('.pet_color').html(p.color);
		d.find('.pet_description').html(p.description);
		d.find('.pet_collar').text(p.collar == 1 ? 'YES' : 'NO');
		d.find('.pet_status').text(pet_statuses[p.status].name);
		d.find('.lost_date').text(moment(p.pet_created).format("MMM Do YYYY"));
		d.find('.contact_submitter').data('user_id',p.created_by);

		$('.contact_submitter').show();
		$('.submitter_data, .submitter_error').hide();

		if (userLoggedIn) {
			if (userData.client_info.acct_type == 10 || userData.user == p.created_by) {
				d.find('.del_pet').data('id', p.pet_id);
				d.find('.edit_pet').data('id', p.pet_id).attr('href', '/report-' + viewMode + '-pet.html?pet[is_edit]=1&pet[pet_id]=' + p.pet_id);

				if (userData.client_info.acct_type == 10 || p.approved == 0) {
					d.find('.edit_pet').removeClass('conf_link');
				}


				d.find('.admin_buttons').show();
				if (userData.client_info.acct_type == 10 && !p.approved) {
					d.find('.approve_pet').data('pet_id', p.pet_id);
				} else {
					d.find('.approve_pet').remove();
				}

			} else {
				d.find('.admin_buttons').remove();
			}
		} else {
				d.find('.admin_buttons').remove();
		}


		if (p.photos.length) {
			d.find('.thumb-list').empty();
			if (typeof p.photos == "object") {
				//console.log('photos found');
				if (p.photos.length >= 1) {
				//console.log('enough photos found');
					$.each(p.photos, function(i,photo) {
						var pc = $('#photo_prototype').clone().removeClass('d-none').removeAttr('id');
						var aif = photo.filename;
						var aifw = aif.replace(/\.[^/.]+$/, '.webp');

						if (photo.pp_id == p.highlight_photo) {
							d.find('picture.highlight_photo > img').attr('src','/art/pet_photos/570x428/' + aif).attr('srcset','/art/pet_photos/545x409/' + aif + ' 545w,/art/pet_photos/737x553/' + aif + ' 737w,/art/pet_photos/548x411/' + aif + ' 548w,/art/pet_photos/570x428/' + aif + ' 570w,/art/pet_photos/570x428/' + aif).attr('alt', p.name);
							d.find('picture.highlight_photo > source').attr('srcset', '/art/pet_photos/545x409/' + aifw + ' 545w,/art/pet_photos/737x553/' + aifw + ' 737w,/art/pet_photos/548x411/' + aifw + ' 548w,/art/pet_photos/570x428/' + aifw + ' 570w,/art/pet_photos/570x428/' + aifw);
							d.find('picture.highlight_photo > img').attr('src','/art/pet_photos/' + p.photos[0].filename);
						}

						pc.find('img').attr('src','/art/pet_photos/130sq/' + aif).attr('srcset', '/art/pet_photos/172sq/' + aif + ' 172w, /art/pet_photos/125sq/' + aif + ' 125w, /art/pet_photos/130sq/' + aif + ' 130w, /art/pet_photos/130sq/' + aif);
						pc.find('source').attr('srcset', '/art/pet_photos/172sq/' + aifw + ' 172w, /art/pet_photos/125sq/' + aifw + ' 125w, /art/pet_photos/130sq/' + aifw + ' 130w,/art/pet_photos/130sq/' + aifw);
						pc.find('a').attr('href', '/art/pet_photos/' + aif);
						//pc.find('img').attr('src', '/art/pet_photos/' + aif);
						d.find('.thumb-list').removeClass('d-none').append(pc);
						pc.show();
						//console.log('img added');
					});
				}
			}
			social_img = 'data-media="/art/pet_photos/' + p.photos[0].filename + '"';
		} else {
			d.find('.thumb-list').empty();
			var aif = 'PetsNoImage.jpg';
			var aifw = aif.replace(/\.[^/.]+$/, '.webp');
			d.find('picture.highlight_photo > img').attr('src','/art/pet_photos/570x428/' + aif).attr('srcset','/art/pet_photos/545x409/' + aif + ' 545w,/art/pet_photos/737x553/' + aif + ' 737w,/art/pet_photos/548x411/' + aif + ' 548w,/art/pet_photos/570x428/' + aif + ' 570w,/art/pet_photos/570x428/' + aif).attr('alt', p.name);
			d.find('picture.highlight_photo > source').attr('srcset', '/art/pet_photos/545x409/' + aifw + ' 545w,/art/pet_photos/737x553/' + aifw + ' 737w,/art/pet_photos/548x411/' + aifw + ' 548w,/art/pet_photos/570x428/' + aifw + ' 570w,/art/pet_photos/570x428/' + aifw);
		}

		if (markers.length) {
			$.each(markers, function(i,m){
				if (m.markerFor == p.pet_id) {
					map.panTo(m.getPosition());
					map.setZoom(parseInt(pet_zoom));
					return false;
				}
			})
		} else {
			let marker = addMarker(p)
			limits.extend(marker.position);
			map.fitBounds(limits);
			map.setZoom(parseInt(pet_zoom));
		}

		$('#pet_list').hide();
		d.show();

		d.find('.pet_social').html('<!-- AddToAny BEGIN --><a class="a2a_dd" href="https://www.addtoany.com/share"><img src="https://static.addtoany.com/buttons/share_save_171_16.png" width="171" height="16" border="0" alt="Share"></a><script>a2a_config.track_links = \'ga\';</script><script async src="https://static.addtoany.com/menu/page.js"></script><!-- AddToAny END -->');

		$('html, body').animate({scrollTop: scrollOffset}, 100, "easeInOutExpo", function() {
			$("a.pet-thumb-link:visible").magnificPopup({
				type:'image',
				gallery:{
			 	   enabled:true
				}
			});
		});
	} else {
		$('#no-pet').show();
		$('.pet_map_wrapper').hide();
	}
}

function view_pets(dMode) {
	pageState = 'listing';

	$('#pet_list').empty();
	$('#no-pet').hide();
	$('.pet_map_wrapper').show();



	updateLables();

	$('.' + viewMode + '_pets_message').show();

	$('a.login').attr('href', '/login.html?return_url=' + window.location.pathname);

	$('.map-controls, .show_pets');
	$('.show_pets').hide();

	if (markers.length) {
		$.each(markers, function(i,m){
			m.setMap(null);
			m = null;
		})
		markers = [];
	}

	$.each(pOrder, function (i,po){
		let p = pets[po];
		if (p) {
			if (showPet(p)) {
				let pet = $('#pet-listing-proto').clone().removeAttr('id');
				pet.attr('id', 'pet_' + p.pet_id);
				pet.data('pet_id', p.pet_id);
				pet.find('.pet_type').text(pet_types[p.pet_type].name);
				if (p.name) {
					pet.find('.pet_name').text(p.name);
				} else {
					pet.find('.pet_name_row').remove();
				}
				pet.find('.pet_color').html(p.color);
				pet.find('.pet_description').html(p.description);
				pet.find('.pet_collar').text(p.collar == 1 ? 'YES' : 'NO');
				pet.find('.pet_status').text(pet_statuses[p.status].name);
				pet.find('.lost_date').text(moment(p.pet_created).format("MMM Do YYYY"));

				if (!p.approved) {
					pet.find('.border-gray-300').addClass('needs-approval');
				}

				if (userLoggedIn) {
					if (userData.client_info.acct_type == 10 || userData.user == p.created_by) {
						pet.find('.del_pet').data('id', p.pet_id);
						pet.find('.edit_pet').data('id', p.pet_id).attr('href', '/report-' + viewMode + '-pet.html?pet[is_edit]=1&pet[pet_id]=' + p.pet_id);

						if (userData.client_info.acct_type == 10 || p.approved == 0) {
							pet.find('.edit_pet').removeClass('conf_link');
						}

						pet.find('.admin_buttons').show();
						if (userData.client_info.acct_type == 10 && !p.approved) {
							pet.find('.approve_pet').data('pet_id', p.pet_id);
						} else {
							pet.find('.approve_pet').remove();
						}

					} else {
						pet.find('.admin_buttons').remove();
					}
				} else {
						pet.find('.admin_buttons').remove();
				}

				if (p.photos.length) {

					let aif = '';
					let aifw = '';

					$.each(p.photos, function(i,pho){
						if(pho.pp_id == p.highlight_photo) {
							aif = pho.filename;
						}
					})

					if (aif) {
						aifw = aif.replace(/\.[^/.]+$/, '.webp');
					}

					pet.find('img').attr('src', '/art/pet_photos/' + p.photos[0].filename).addClass('view_pet').data('pet_id', p.pet_id);

					if (aif) {
						pet.find('picture.highlight_photo > img').attr('src','/art/pet_photos/348x233/' + aif).attr('srcset', '/art/pet_photos/523x350/' + aif + ' 523w,/art/pet_photos/320x214/' + aif + ' 320w,/art/pet_photos/278x186/' + aif + ' 278w,/art/pet_photos/348x233/' + aif + ' 348w,/art/pet_photos/348x233/' + aif).attr('alt',p.name).show();
						pet.find('picture.highlight_photo > source').attr('srcset', '/art/pet_photos/523x350/' + aifw + ' 523w, /art/pet_photos/320x214/' + aifw + ' 320w, /art/pet_photos/278x186/' + aifw + ' 278w, /art/pet_photos/348x233/' + aifw + ' 348w,/art/pet_photos/348x233/' + aifw);
					} else {
						pet.find('picture.highlight_photo > img').hide();
					}

				}
				pet.find('.view_pet').data('pet_id', p.pet_id);
				$(pet.find('img')).on('load', function(e) {
					macy.recalculate(true);
				});

				let marker = addMarker(p);

			  limits.extend(marker.position);
				map.fitBounds(limits);
				$('#pet_list').append(pet);
				pet.fadeIn();
			}
		}
	})


	if (pop_nav == 1) {
		pop_nav = 0;
	} else {
		if (dMode) {
			history.pushState({
				'action': 'load_pets',
				'dMode': dMode
			}, 'View Pets', '/pets/' + dMode);

		} else {
			history.pushState({
				'action': 'load_pets',
			}, 'View Pets', '/pets.html');
		}
	}

	$('html, body').animate({scrollTop: scrollOffset}, 100, "easeInOutExpo", function() {});
	macy.reInit();
	macy.recalculate(true);
	new markerClusterer.MarkerClusterer({ markers, map });

}

function updateLables() {
	if (viewMode == 'lost') {
		$('.lorf').text('Lost');
		new_title[0] = 'View Lost Pets';
		$('.contactTitle').text('Owner');
	} else {
		$('.lorf').text('Found');
		new_title[0] = 'View Found Pets';
		$('.contactTitle').text('Finder');
	}
	$('head > title').text(new_title.join(' - '));
}

function addMarker(p){
	let icon = petIcons[p.pet_type];
	icon.fillColor = (p.status == 6 ? '#2079e2' : '#18a04f');
	icon.strokeColor = icon.fillColor;
	icon.anchor = new google.maps.Point(192,512);
	const myLatLng = new google.maps.LatLng(p.loc_lat, p.loc_lng);
	const marker = new google.maps.Marker({
		position: myLatLng,
		icon: icon,
		map: map,
		title: p.name,
		markerFor: p.pet_id
	});

	markers.push(marker);

	google.maps.event.addListener(marker, 'click', function(){
		map.panTo(this.getPosition());
		var pet = $('#pet-pop-proto').clone().removeAttr('id').show();

		pet.attr('id', 'pet_' + p.pet_id);
		pet.data('pet_id', p.pet_id);
		pet.find('.view_pet').data('pet_id', p.pet_id);
		pet.find('.pet_type').text(pet_types[p.pet_type].name);
		pet.find('.pet_name').text(p.name);
		pet.find('.pet_color').html(p.color);
		pet.find('.pet_description').html(p.description);
		pet.find('.pet_collar').text(p.collar == 1 ? 'YES' : 'NO');
		pet.find('.pet_status').text(pet_statuses[p.status].name);
		pet.find('.lost_date').text(moment(p.created).format("MMM Do YYYY"));
		if (p.photos.length) {
			let aif = '';

			$.each(p.photos, function(i,pho) {
				if (pho.pp_id == p.highlight_photo) {
					aif = pho.filename;
				}
			})
			if (aif) {
				pet.find('img').attr('src','/art/pet_photos/130sq/' + aif);
			}
		} else {
			pet.find('img').hide();
		}
		pet.find('.view_pet').data('pet_id', p.pet_id);
		infoWindow.setContent($(pet)[0]);
		infoWindow.open(map, marker);

	});
	return marker;
}

function showPet(p) {
	let visible = false;

	// Filter visiblity based on approval
	if (p.approved == 1) {
		visible = true;
	} else {
//		if (userData.user == p.created_by) {
//			visible = true;
//		}
		if (userData.client_info.acct_type == 10) {
			visible = true;
		}
	}

	if (visible) {
		// Filter visiblity based on status
		if (viewMode === 'lost') {
			if (p.status == 6) {
				visible = true;
			} else {
				visible = false;
			}
		}
		else {
			if (p.status != 6) {
				visible = true;
			} else {
				visible = false;
			}
		}
	}

	return visible;
}

function initMap() {
	map = new google.maps.Map(document.getElementById("pet_map"), {
		center: { lat: 32.7205172, lng: -114.6074127 },
		zoom: 14,
		styles: mapStyles
	});
	infoWindow = new google.maps.InfoWindow();
 	limits = new google.maps.LatLngBounds();

	google.maps.event.addListener(map, 'click', function(event) {
	  if (infoWindow) {
	    infoWindow.close();
	    $('.location').removeClass('active');
	  }
	  map.fitBounds(limits);
	});

	google.maps.event.addListener(infoWindow, 'closeclick', function(event){
	  map.fitBounds(limits);
	});

}

function handleLocationError(browserHasGeolocation, infoWindow, pos) {
	$('.loading_msg').hide();
	var errText = browserHasGeolocation ? "Error: The Geolocation service failed." : "Error: Your browser doesn't support geolocation." ;
	$('.map-error').text(errText).fadeIn();
}


function delPet(pet_id) {
	$('#pets-wait-msg').html('Deleting Pet');
	$('#pets-wait').show();
	$.ajax({
		type  : 'POST',
		url: '/utils/del_pet.php',
		dataType  : 'json',
		data : {
			'pet[pet_id]': pet_id,
			'del[reason]': $('#del_reason_input').val(),
			'del[descr]': $('#del_descr').val()
		},
		xhrFields: { withCredentials: true },
		crossDomain: true,
		encode  : true
	})
	.done(function(data) {
		$('#pets-wait').hide();
		if ( data.success == false ) {
			//console.log(data);
			$('#pets-err-msg').html('Unable to delete pet: ' + data.error_msg);
			$('#pets-err').show();
			$('#pets').hide();
		} else {
			if (pageState == 'listing') {
				$('#pet_' + pet_id).hide("slow",function(){
					$(this).remove();
					macy.recalculate(true);
				});
			} else {
				$('.pet_return').click();;
			}
		}
	})
	.fail(function(XMLHttpRequest, textStatus, errorThrown) {
		console.log(XMLHttpRequest);
		console.log(textStatus);
		console.log(errorThrown);
		$('#pets-wait').hide();
		$('#pets-err-msg').html('Unable to delete pet: ' + textStatus + ' ' + errorThrown);
		$('#pets-err').show();
	});
}

window.initMap = initMap;